import { createSlice } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status?: ReduxStateType;
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,
};

const handleVoteSlice = createSlice({
  name: "handleVote",
  initialState,
  reducers: {
    handleVoteStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    handleVoteSuccess: (state) => {
      state.status = ReduxStateType.SUCCESS;
    },
    handleVoteFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetVotedStatus: (state) => {
      state.status = ReduxStateType.INIT;
    },
  },
});

export const {
  handleVoteStart,
  handleVoteSuccess,
  handleVoteFailed,
  resetVotedStatus,
} = handleVoteSlice.actions;

export default handleVoteSlice.reducer;
